import React from 'react';
import { DataGridPro } from '@mui/x-data-grid-pro';
/**
 * A styled DataGridPro component with consistent styling across the application.
 *
 * Features:
 * - Dark gray header (#374151) with white text
 * - Uppercase header titles
 * - Comfortable row height (56px default)
 * - Hover effects on rows
 * - Styled footer and toolbar
 *
 * All DataGridPro props are supported and can override the defaults.
 */
const StyledDataGrid = ({ customRowHeight = 56, customHeaderHeight = 48, sx, ...props }) => {
    const baseStyles = {
        border: 'none',
        // CSS variables for header theming (recommended by MUI)
        '--DataGrid-t-header-background-base': '#374151',
        '& .MuiDataGrid-columnHeader': {
            backgroundColor: '#374151',
            color: '#ffffff',
            fontSize: '0.875rem',
            fontWeight: 500,
            paddingLeft: '24px',
            paddingRight: '24px',
        },
        '& .MuiDataGrid-columnHeaders': {
            backgroundColor: '#374151',
            '--DataGrid-t-header-background-base': '#374151',
        },
        '& .MuiDataGrid-columnHeaderRow': {
            backgroundColor: '#374151 !important',
        },
        '& .MuiDataGrid-columnHeaderTitle': {
            fontWeight: 500,
            textTransform: 'uppercase',
            color: '#ffffff',
        },
        '& .MuiDataGrid-columnSeparator': {
            color: '#4b5563',
        },
        '& .MuiDataGrid-iconButtonContainer': {
            color: '#ffffff',
        },
        '& .MuiDataGrid-sortIcon': {
            color: '#ffffff !important',
        },
        '& .MuiDataGrid-menuIconButton': {
            color: '#ffffff !important',
        },
        '& .MuiDataGrid-cell': {
            fontSize: '0.875rem',
            borderBottom: '1px solid #e5e7eb',
            paddingLeft: '24px',
            paddingRight: '24px',
        },
        '& .MuiDataGrid-row:hover': {
            backgroundColor: '#f9fafb',
        },
        '& .MuiDataGrid-footerContainer': {
            backgroundColor: '#f9fafb',
            borderTop: '1px solid #e5e7eb',
        },
        '& .MuiDataGrid-toolbarContainer': {
            padding: '8px 16px',
            backgroundColor: '#f9fafb',
            borderBottom: '1px solid #e5e7eb',
        },
        '& .MuiTablePagination-root': {
            color: '#4b5563',
        },
    };
    return (React.createElement(DataGridPro, { rowHeight: customRowHeight, columnHeaderHeight: customHeaderHeight, ...props, sx: {
            ...baseStyles,
            ...sx,
        } }));
};
export default StyledDataGrid;
